import React, { useState, useEffect } from 'react';
import { Modal, Input, Spin, message } from 'antd';
import { ref, onValue, update, get } from 'firebase/database';
import { useFirebase } from '../FirebaseContext';
import { WarningCircle } from '@phosphor-icons/react';

const NegativeBalanceDrivers = () => {
  const { currentFirebase } = useFirebase();
  const db = currentFirebase.database;

  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [amount, setAmount] = useState('');
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    setLoading(true);
    const driversRef = ref(db, 'drivers');
    const unsubscribe = onValue(driversRef, (snapshot) => {
      const list = [];
      snapshot.forEach((child) => {
        const balance = Number(child.val().balance);
        if (balance < 0) list.push({ id: child.key, balance });
      });
      list.sort((a, b) => a.balance - b.balance);
      setDrivers(list);
      setLoading(false);
    }, () => { setLoading(false); });
    return () => unsubscribe();
  }, [db]);

  const handleDeposit = async () => {
    if (!amount || Number(amount) <= 0) return message.warning('Wprowadź poprawną kwotę.');
    try {
      const driverRef = ref(db, `drivers/${selectedDriver}`);
      const snap = await get(driverRef);
      if (snap.exists()) {
        const newBalance = Number(snap.val().balance) + Number(amount);
        await update(driverRef, { balance: newBalance });
        message.success('Saldo zaktualizowane.');
      }
      setIsModalVisible(false);
      setAmount('');
    } catch (e) {
      message.error('Błąd: ' + e.message);
    }
  };

  const visible = showAll ? drivers : drivers.slice(0, 5);

  return (
    <div className="dash-card">
      <div className="dash-card-header">
        <span className="dash-card-title">Ujemne salda</span>
        <span className="dash-card-count" style={{ background: drivers.length > 0 ? '#fef2f2' : undefined, color: drivers.length > 0 ? '#dc2626' : undefined }}>
          {drivers.length}
        </span>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 24 }}><Spin /></div>
      ) : drivers.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 24, color: '#9ca3af', fontSize: 13 }}>
          Brak kierowców z ujemnym saldem
        </div>
      ) : (
        <>
          <div className="dash-balance-list">
            {visible.map((d) => (
              <div key={d.id} className="dash-balance-item">
                <div className="dash-balance-left">
                  <WarningCircle size={16} weight="fill" color="#dc2626" />
                  <span className="dash-balance-id">{d.id}</span>
                </div>
                <div className="dash-balance-right">
                  <span className="dash-balance-amount">{d.balance.toFixed(2)} zł</span>
                  <button className="dash-balance-btn" onClick={() => { setSelectedDriver(d.id); setIsModalVisible(true); }}>
                    Wpłać
                  </button>
                </div>
              </div>
            ))}
          </div>
          {drivers.length > 5 && (
            <button className="dash-show-all" onClick={() => setShowAll(!showAll)}>
              {showAll ? 'Pokaż mniej' : `Pokaż wszystkich (${drivers.length})`}
            </button>
          )}
        </>
      )}

      <Modal
        title={`Wpłata — ${selectedDriver}`}
        open={isModalVisible}
        onOk={handleDeposit}
        onCancel={() => { setIsModalVisible(false); setAmount(''); }}
        okText="Wpłać"
        centered
        width={400}
      >
        <Input
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="Kwota"
          style={{ borderRadius: 8 }}
        />
      </Modal>
    </div>
  );
};

export default NegativeBalanceDrivers;
